<template>
    <section>
        <div class="form-group">
            <span v-html="$t('validation.field_required')"></span>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <required /> <label>CPF / CNPJ</label>
                    <input name="Documento" :class="{ 'is-invalid': errors.has('Documento')}" v-validate="{required: true,  document:true}"
                        v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="usuario.documento"
                        placeholder="Insira o documento" class="form-control">
                    <div class="invalid-feedback help-block error">{{errors.first('Documento')}}</div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="form-group">
                    <required /> <label>Nome Completo</label>
                    <input name="Nome" :class="{ 'is-invalid': errors.has('Nome')}" v-validate="{required: true}" v-model="usuario.nome"
                        placeholder="Insira o nome completo" class="form-control">
                    <div class="invalid-feedback help-block error">{{errors.first('Nome')}}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <required /> <label>DDD + Número</label>
                    <input name="Telefone"  :class="{ 'is-invalid': errors.has('Telefone')}" v-mask="['(##)####-####', '(##)#####-####']" v-validate="{required: true}"
                        v-model="usuario.telefone" placeholder="Insira o número" class="form-control">
                    <div class="invalid-feedback help-block error">{{errors.first('Telefone')}}</div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group" >
                    <required /> <label>Nascimento</label>
                    <input name="Nascimento" :class="{ 'is-invalid': errors.has('Nascimento')}" type="date" v-validate="{required: true}" v-model="usuario.nascimento"
                        class="form-control">
                    <div class="invalid-feedback help-block error">{{errors.first('Nascimento')}}</div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <required /> <label>Permissão Padrão</label>
                    <select name="Permissao"  :class="{ 'is-invalid': errors.has('Permissao')}" v-validate="{required: true}" v-model="usuario.fk_cargo_id"
                        class="form-control">
                        <option :value="null">{{$t('words.select')}}</option>
                        <option v-for="(item, i) in cargos" :key="i" :value="item.id">{{item.cargo_nome}}</option>
                    </select>
                    <div class="invalid-feedback help-block error">{{errors.first('Permissao')}}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <required /> <label>E-mail</label>
                    <input name="Email" :class="{ 'is-invalid': errors.has('Email')}" v-validate="{required: true, email: true}" v-model="usuario.email"
                        placeholder="Insira o e-mail" type="email" class="form-control">
                    <div class="invalid-feedback help-block error">{{errors.first('Email')}}</div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <required /> <label>Senha</label>
                    <input type="password" :class="{ 'is-invalid': errors.has('Senha')}" name="Senha" ref="Senha" v-validate="{required: true}"
                        v-model="usuario.password" placeholder="Insira a senha" class="form-control">
                    <div class="invalid-feedback help-block error">{{errors.first('Senha')}}</div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <required /> <label>Confirmar Senha</label>
                    <input type="password" :class="{ 'is-invalid': errors.has('SenhaConfirma')}" name="SenhaConfirma" v-validate="{required: true, confirmed: 'Senha' }"
                        v-model="usuario.password_confirmation" placeholder="Confirmar Senha" class="form-control">
                    <div class="invalid-feedback help-block error">{{errors.first('SenhaConfirma')}}</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            usuario: {}
        },
        computed: {
            cargos() {
                return this.$store.state.cargo.select;
            }
        },
        beforeMount() {
            this.$store.dispatch('getAllCargos');
        },
        methods: {
            validateAll() {
                return this.$validator.validateAll().then(valid => {
                    return valid;
                });
            }
        }
    }
</script>